module.exports = __webpack_public_path__ + "static/media/interview.54a3040a.svg";